<template>
  <div>
    <div class="container-pro" :style="myClass">
      <router-view></router-view>
    </div>
    <section class="bottomMenu" style="">
      <section @click="menuClick(0)" :class="active == 0 ? 'menuList active' : 'menuList'">
        <i class="iconfont">&#xe70c;</i>
        <span>商城</span>
      </section>
      <section @click="menuClick(1)" :class="active == 1 ? 'menuList active' : 'menuList'">
        <i class="iconfont" style="font-size:2.5rem;">&#xe8aa;</i>
        <span>服务</span>
      </section>
      <section @click="menuClick(3)" class="menuList">
        <i class="iconfont">&#xe670;</i>
        <span>纪念堂</span>
      </section>
      <section @click="menuClick(2)" :class="active == 2 ? 'menuList active' : 'menuList'">
        <i class="iconfont">&#xe600;</i>
        <span>我的</span>
      </section>
    </section>
  </div>
</template>

<script>
import bus from '../../common/bus'
export default {
  name: 'shopIndex',
  data() {
    return {
      active: 0,
      myClass: '',
    }
  },
  created() {
    let _url = this.$route.fullPath
    if (_url.indexOf('my') > -1 || _url.indexOf('tsjy') > -1 || _url.indexOf('shopservices') > -1) {
      this.myClass = 'padding:0;'
    } else {
      this.myClass = ''
    }

    if (_url.indexOf('my') > -1) {
      this.active = 2
    }
    bus.$off('menuClick')
    bus.$on('menuClick', msg => {
      this.active = msg
    })
  },
  methods: {
    menuClick(id) {
      this.active = id
      if (id == 0) {
        this.$router.push({ path: '/shop' })
      } else if (id == 1) {
        this.$router.push({ path: '/shop/services' })
      } else if (id == 2) {
        this.$router.push({ path: '/my' })
      } else if (id == 3) {
        this.$router.push({ path: '/jnt' })
      }
    },
  },
  watch: {
    $route() {
      let _url = this.$route.fullPath
      if (
        _url.indexOf('my') > -1 ||
        _url.indexOf('tsjy') > -1 ||
        _url.indexOf('shopservices') > -1
      ) {
        this.myClass = 'padding:0;'
      } else {
        this.myClass = ''
      }
      if (_url.indexOf('my') > -1) {
        this.active = 2
      }
    },
  },
}
</script>

<style>
.bottomMenu {
  background-color: #fff;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 5rem;
  display: flex;
  box-shadow: 0 -0.027rem 0.05333rem rgb(0 0 0 / 10%);
  padding: 0.5rem;
}
.bottomMenu .menuList {
  flex: 1;
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  font-size: 1.1rem;
}
.bottomMenu .menuList.active i {
  color: #dea767;
  font-size: 2.1rem;
}

.bottomMenu .menuList i {
  color: #4c4c4c;
  font-size: 2.1rem;
}

.bottomMenu .menuList .icon_style {
  width: 2.5rem;
  height: 2.5rem;
  margin-top: 0.6rem;
  fill: #ccc;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
}
.bottomMenu .menuList.active {
  font-size: 1.1rem;
  color: #323232;
}

.bottomMenu .menuList {
  font-size: 1.1rem;
  color: #999;
}
</style>
